/*
  Paginas Contrarrevolucionarias
  En Estados Unidos, Mexico y Puerto Rico el libro en PAPEL se compra en Amazon,
  pero el EBOOK y el AUDIOLIBRO se venden aqui con normalidad.
  El selector de formato de Dawn no vuelve a dibujar el boton de compra, asi que
  al pasar de un formato fisico a uno digital (o al reves) hay que recargar la
  ficha para que salgan el precio y el boton correctos.
*/
(function () {
  var COUNTRIES = ['US', 'MX', 'PR'];
  var country = (window.Shopify && window.Shopify.country) || '';
  if (COUNTRIES.indexOf(country) === -1) return;

  var info = document.querySelector('product-info');
  if (!info || !info.dataset || !info.dataset.url) return;

  var renderedPhysical = !!document.querySelector('.product-form__buttons a[href*="amazon."]');

  fetch(info.dataset.url + '.js')
    .then(function (r) { return r.json(); })
    .then(function (p) {
      var map = {};
      (p.variants || []).forEach(function (v) { map[String(v.id)] = !!v.requires_shipping; });
      var last = window.location.search;
      setInterval(function () {
        if (window.location.search === last) return;
        last = window.location.search;
        var m = /[?&]variant=(\d+)/.exec(window.location.search);
        if (!m) return;
        var physical = map[m[1]];
        if (physical === undefined) return;
        if (physical !== renderedPhysical) window.location.reload();
      }, 250);
    })
    .catch(function () {});
})();
